export const routesConfig = {
  AUTH: {
    LOGIN: '/login',
    LOGOUT: '/logout',
    REGISTER: '/register',
    FORGOT: '/forgot',
    FORGOT_SUCCESS: '/forgot-success',
    CONFIRM: '/confirm',
    ACCEPT_INVITATION: '/accept-invitation',
    RESET: '/reset',
    RESET_SUCCESS: '/reset-success',
  },
  SETTINGS: {
    ROOT: '/settings',
    USER_EDIT: '/settings/user',
    PARTNER_EDIT: '/settings/partner',
    TEAM: {
      INDEX: '/settings/team/index',
      INVITE: '/settings/team/invite',
    },
  },
  VEHICLES: {
    SHOW: '/vehicles/:id',
    CHOOSE_PAYMENT: '/vehicles/:id/choose-payment',
    VOUCHER: '/vehicles/:id/choose-payment/voucher',
    BUY: '/vehicles/:id/buy',
    PAYMENT_SUCCESS: '/vehicles/:id/success-payment',
    PAYMENT_CANCEL: '/vehicles/:id/cancel-payment',
  },
  SERVICE_EVENTS: {
    COMPLETE_REMINDER: '/vehicles/:vehicleId/reminders/:id/complete-reminder',
    CREATE: '/vehicles/:vehicleId/service-events/new',
    EDIT: '/vehicles/:vehicleId/service-events/:id/edit',
    SHOW: '/vehicles/:vehicleId/service-events/:id',
  },
  REMINDER: {
    INDEX: '/reminders',
    CREATE: '/vehicles/:vehicleId/reminder/new',
    EDIT: '/vehicles/:vehicleId/reminder/:id/edit',
  },
  SERVICE_CALL: {
    APPLY: '/service-call/apply',
    DASHBOARD: '/service-call/dashboard',
    CUSTOMERS: '/service-call/customers',
    FAULT_SHOW: '/service-call/faults/:id',
    VEHICLE_CREATE: '/service-call/customers/:businessId/vehicles/new',
    CUSTOMER_VEHICLES: '/service-call/customers/:businessId/vehicles-list',
  },
  DASHBOARD: '/',
  REPORT_REMINDER: '/vehicles/:vehicleId/reminder/:id/report',
  FEEDBACK: '/feedback',
};
